import { render } from "./App.vue?vue&type=template&id=3ee59970"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3ee59970&lang=less"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__